var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 11.4287C13.5606 11.4287 15.0957 9.89362 15.0957 8C15.0957 6.10638 13.5606 4.57129 11.667 4.57129C9.77337 4.57129 8.23828 6.10638 8.23828 8C8.23828 9.89362 9.77337 11.4287 11.667 11.4287Z",
    stroke: "#FFD700",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0249 6.78166C21.4684 7.32112 21.6901 7.5897 21.6901 8C21.6901 8.4103 21.4684 8.67889 21.0249 9.21834C19.402 11.1887 15.8224 14.8574 11.6668 14.8574C7.51122 14.8574 3.93165 11.1887 2.30872 9.21834C1.86528 8.67889 1.64355 8.4103 1.64355 8C1.64355 7.5897 1.86528 7.32112 2.30872 6.78166C3.93165 4.8113 7.51122 1.14258 11.6668 1.14258C15.8224 1.14258 19.402 4.8113 21.0249 6.78166Z",
    stroke: "#FFD700",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.fd4403ed09786abf5b2716b034b45d3d.svg";
export { ForwardRef as ReactComponent };